import React from 'react';
import { clientBaseUrl } from '../../services/urls';
import { Center, Stack, Text, Button, Title } from '@mantine/core';

export default function PageError({ onReset }) {
    const handleGoHome = () => {
        onReset?.();
        window.location.replace(clientBaseUrl);
    };

    return (
        <Center h="100vh">
            <Stack align="center" gap="md">
                <Title order={2}>Something went wrong.</Title>
                <Text c="dimmed">An unexpected error occurred on this page.</Text>
                <Button onClick={handleGoHome}>
                    Go to home page
                </Button>
            </Stack>
        </Center>
    );
}
